import { render, staticRenderFns } from "./tagsModal.vue?vue&type=template&id=b36c76ac&scoped=true&"
import script from "./tagsModal.vue?vue&type=script&lang=js&"
export * from "./tagsModal.vue?vue&type=script&lang=js&"
import style0 from "./tagsModal.vue?vue&type=style&index=0&id=b36c76ac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b36c76ac",
  null
  
)

export default component.exports